import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2025 Zirae Chemicals. All rights reserved.</p>
            <div style={{ marginTop: '1rem', fontSize: '1.1rem', color: '#ffd700', fontWeight: 600 }}>
                For business inquiries: <a href="mailto:olajideayomide946@gmail.com" style={{ color: '#00bfae', textDecoration: 'underline' }}>olajideayomide946@gmail.com</a>
            </div>
        </footer>
    );
};

export default Footer;